import { observer } from 'mobx-react';
import Button from '../../../../../../../Form/Button';
import ModalStore from '../../../../../../../Modal/Store';
import { resetModal } from '../..';
import ReclaimLicensesStore from '../../../Store';
import clsx from 'clsx';

interface Props {
  modalStore: ModalStore;
  store: ReclaimLicensesStore;
}

function CancelButton({ modalStore, store }: Props) {
  return (
    <Button
      type="button"
      value="Cancel"
      onClick={() => resetModal(modalStore, store)}
      data-intercom-target="cancel-reclaim-licenses"
      className={clsx(
        'rounded-md border border-solid border-teal-600 bg-white',
        'py-2.5 px-5 text-sm font-semibold text-teal-600',
      )}
    />
  );
}

export default observer(CancelButton);
